import { ChangeEvent, CSSProperties } from 'react';
import { FormField } from './FormField';
import { textFieldStyles } from './fieldStyles';
 
type TextFieldProps = {
  label?: string;
  value: string;
  onChange?: (value: string) => void;
  error?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
};
 
export const TextField = ({
  label,
  value,
  onChange,
  error,
  placeholder,
  disabled,
  maxLength
}: TextFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
	if (!onChange) return
	onChange(e.target.value);
  };
 
  return (
	<FormField label={label} error={error}>
	  <input
		type="text"
		className='form-input'
		value={value}
		onChange={handleChange}
		placeholder={placeholder}
		disabled={disabled}
		maxLength={maxLength}
	  />
	</FormField>
  );
};